
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/textarea-autosize",
      function () {
        return require("private-next-pages/material-ui/api/textarea-autosize.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/textarea-autosize"])
      });
    }
  